import { ErrorHandler, Injectable } from '@angular/core';
import { environment } from '@env';
import { Router } from '@angular/router';
import { AngularPlugin } from '@microsoft/applicationinsights-angularplugin-js';
import { ApplicationInsights, ICustomProperties } from '@microsoft/applicationinsights-web';

@Injectable({
  providedIn: 'root',
})
export class LoggingService {
  private angularPlugin: AngularPlugin;
  private appInsights: ApplicationInsights;

  constructor(private router: Router) {
    this.angularPlugin = new AngularPlugin();
    this.appInsights = new ApplicationInsights({
      config: {
        connectionString: environment.appInsights.connectionString,
        enableAutoRouteTracking: environment.isProduction, // option to log all route changes
        extensions: [this.angularPlugin],
        extensionConfig: {
          [this.angularPlugin.identifier]: {
            router: this.router,
            errorServices: [new ErrorHandler()], // Add base error handler, to enable browser console logs of errors, otherwise they will be only in AppInsights
          },
        },
      },
    });

    if (environment.isProduction) {
      this.appInsights.loadAppInsights();
    }
  }

  logPageView(name?: string, url?: string) {
    // option to call manually
    this.appInsights.trackPageView({
      name: name,
      uri: url,
    });
  }

  logEvent(name: string, properties?: ICustomProperties) {
    this.appInsights.trackEvent({ name: name }, properties);
  }

  logMetric(name: string, average: number, properties?: ICustomProperties) {
    this.appInsights.trackMetric({ name: name, average: average }, properties);
  }

  logException(exception: Error, severityLevel?: number) {
    if (environment.isProduction) {
      this.appInsights.trackException({
        exception: exception,
        severityLevel: severityLevel,
      });
    } else {
      console.log(exception);
    }
  }

  logTrace(message: string, properties?: ICustomProperties) {
    if (environment.isProduction) {
      this.appInsights.trackTrace({ message: message }, properties);
    } else {
      console.log(message);
    }
  }
}
